import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/HomeView.vue'),
        meta: {
            title: 'PSB Penabur Jakarta – Sekolah Kristen Favorite Terbaik',
            description: 'Portal resmi PSB Penabur Jakarta. Daftar online TK-SD-SMP-SMA-SPK Kristen & International.',
            keywords: 'psb penabur,psb penabur jakarta,bpk penabur,sekolah kristen terbaik',
            layout: true
        }
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/FaqView.vue'),
        meta: {
            title: 'FAQ PSB Penabur – Biaya, Jadwal, Syarat',
            description: 'Jawaban lengkap biaya sekolah BPK Penabur International, uang pangkal, beasiswa.',
            keywords: 'biaya sekolah bpk penabur international',
            layout: true
        }
    },
    {
        path: '/enroll',
        name: 'enroll',
        component: () => import('@/views/EnrollView.vue'),
        meta: {
            title: 'Pendaftaran PSB Penabur Jakarta',
            description: 'Portal pendaftaran online BPK Penabur Jakarta untuk semua jenjang pendidikan.',
            keywords: 'pendaftaran bpk penabur jakarta, daftar sekolah penabur',
            layout: false // This route won't use layout
        }
    },
    {
        path: '/schools',
        name: 'school',
        component: () => import('@/views/SchoolView.vue'),
        props: route => ({ level: route.query.level }),
        meta: {
            layout: true,
            // Dynamic meta will be handled in beforeEnter
        },
        beforeEnter: (to, from, next) => {
            const level = to.query.level;
            const levelUpper = level?.toUpperCase() || '';
            const levelName = level || 'Semua Jenjang';
            
            // Set dynamic meta
            to.meta.title = `Sekolah ${levelUpper} BPK Penabur Jakarta`;
            to.meta.description = `Daftar & fasilitas sekolah ${levelName} BPK Penabur – jenjang unggulan Kristen.`;
            to.meta.keywords = `${level || 'sekolah'} bpk penabur jakarta,penabur intercultural school`;
            
            next();
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/ContactView.vue'),
        meta: {
            title: 'Hubungi PSB Penabur Jakarta – Info & Lokasi',
            description: 'Alamat, telepon, WhatsApp, dan email PSB Penabur Jakarta.',
            keywords: 'portal penabur,sas penabur login',
            layout: true
        }
    },
    {
        path: '/privacy-policy',
        name: 'privacy',
        component: () => import('@/views/PrivacyView.vue'),
        meta: {
            title: 'Kebijakan Privasi PSB Penabur Jakarta',
            description: 'Kebijakan privasi penggunaan data pada portal PSB Penabur Jakarta.',
            keywords: 'kebijakan privasi psb penabur jakarta, portal penabur,sas penabur login',
            layout: true
        }
    },
    // 404 redirect to home
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Handle saved position (back/forward buttons)
        if (savedPosition) {
            return savedPosition;
        }
        
        // Handle anchor links
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
                top: 80 // Offset for fixed header if you have one
            };
        }
        
        // Smooth scroll to top for new routes
        return { 
            top: 0,
            behavior: 'smooth'
        };
    },
});

// Global navigation guard for meta tags
router.beforeEach((to, from, next) => {
    // Set document title
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    
    // Set meta description
    if (to.meta.description) {
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }
        metaDescription.content = to.meta.description;
    }
    
    // Set meta keywords
    if (to.meta.keywords) {
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = to.meta.keywords;
    }
    
    next();
});

export default router;